export default "__VITE_ASSET__91003741__"